/** dev/local Admin 호스트 — production adm.lettaga.ai 등은 제외 */
function isDevAdminHostname(host: string): boolean {
  const h = String(host || '').trim().toLowerCase();
  if (!h || h === 'localhost' || h === '127.0.0.1') return true;
  if (h.startsWith('dev.')) return true;
  if (h.startsWith('dev-adm.')) return true;
  return false;
}

/** Admin dev/local 전용 메뉴·라우트 노출 여부 (production adm 에서는 숨김) */
export function isDevOrLocalAdmin(): boolean {
  if (import.meta.env.DEV) return true;

  // 브라우저: hostname 우선 (production 빌드라도 dev-adm.lettaga.ai 에서 노출)
  if (typeof window !== 'undefined') {
    return isDevAdminHostname(window.location.hostname);
  }

  const env = String(import.meta.env.VITE_APP_ENV || '').toLowerCase();
  if (env === 'production') return false;
  return env === 'development' || env === 'local' || env === 'localdev';
}

export function isMarketingPath(path: string): boolean {
  return path === '/main/marketing' || path.startsWith('/main/marketing/');
}
